import { api } from "utils";
import { PUBLIC_V1, PUBLIC_V2 } from "constant/URL";
import { objectToQueryParams } from "utils/objectToQueryParams";

export const getListInvoiceListingCount = async (params = {}) => {
  const newParams =
    !!params && typeof params === "object"
      ? `?${objectToQueryParams(params)}`
      : "";
  return api({}, true).get(`/${PUBLIC_V1}/invoices/count${newParams}`);
};

export const getDetailInvoice = async (id) => {
  return api({}, true).get(`/${PUBLIC_V1}/training-billings/${id}`);
};

export const getListVoucher = async (params = {}) => {
  const newParams =
    !!params && typeof params === "object"
      ? `?${objectToQueryParams(params)}`
      : "";
  return api({}, true).get(`/${PUBLIC_V1}/voucher${newParams}`);
};

export const applyVoucher = async (id, data) => {
  return api({}, true).post(
    `/${PUBLIC_V1}/training-billings/${id}/invoices-discount`,
    data
  );
};

export const getListInvoice = async (params = "") => {
  const newParams =
    !!params && typeof params === "object"
      ? `?${objectToQueryParams(params)}`
      : "";
  return api({}, true).get(`/${PUBLIC_V1}/invoices${newParams}`);
};

export const getInvoiceDetail = async (id) => {
  return api({}, true).get(`/${PUBLIC_V1}/invoices/${id}`);
};

export const getListInvoiceV2 = async (params = "") => {
  const newParams =
    !!params && typeof params === "object"
      ? `?${objectToQueryParams(params)}`
      : "";
  return api({}, true).get(`/${PUBLIC_V2}/invoices${newParams}`);
};

export const getDetailInvoiceV2 = async (params) => {
  const newParams = (!!params && typeof params === "object") ? `?${objectToQueryParams(params)}` : ""
  return api({}, true).get(`/${PUBLIC_V2}/invoices/detail${newParams}`)
}

export const postDownloadInvoice = async (params = {}) => {
  const newParams = (!!params && typeof params === "object") ? `?${objectToQueryParams(params)}` : ""
  return api({}, true, { responseType: 'arraybuffer' }).post(`/${PUBLIC_V2}/invoices/download${newParams}`)
}

export const postPaymentInvoice = async (params = {}) => {
  const newParams = (!!params && typeof params === "object") ? `?${objectToQueryParams(params)}` : ""
  return api({}, true).post(`/${PUBLIC_V2}/invoices/payment${newParams}`)
}
